import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
// import { Route, HashRouter as Router, Routes } from "react-router-dom";
import { ErrorBoundary } from 'react-error-boundary';
// import ThemeToggle from 'Components/ThemeToggle'
import 'react-phone-input-2/lib/material.css';
import "font-awesome/css/font-awesome.css";
import { Button } from '@mui/material';
import PropTypes from 'prop-types';
import moment from 'moment';
import ReactGA from 'react-ga';
import Snackbar from '@mui/material/Snackbar';
import Slide from '@mui/material/Slide';

import { POST_URL, NOTIFICATION_POST_URL } from 'Includes/urls';
import { postNotificationRequest } from 'Includes/api/apicall';
import Dashboard from './Components/Dashboard';
import Loginpage from 'Components/Loginpage';
import CompanyList from 'Containers/Company/CompanyList';
import ChatbotWidget from 'Components/ChatbotWidget/ChatbotWidget';
import SchoolCollegeSync from 'Components/AreaSearch/SchoolCollegeSync';
// import PrivateRoute from './PrivateRoute';
import GATrackingIds from "Constants/GoogleAnalyticsMapping";
import './AppResponsive.scss';
import './App.scss';
import { TOKEN_EXPIRY_BUFFER_TIME, REFRESH_TOKEN_TIME, DEFAULT_THEME } from 'Constants'
import { fetchToken, onMessageListener } from './firebase';
import MuiAlert from '@mui/material/Alert';
import edubricz from 'images/edubricz.jpeg'
import { postRequest } from 'Includes/api/apicall';
import { getPathName } from 'Includes/functions';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const localTheme = localStorage.getItem('theme') ? localStorage.getItem('theme') : DEFAULT_THEME;
const errorReceivers = [];

function App(props) {
  let lastActivityTime = new Date().getTime();
  const [theme, setThemeState] = React.useState(localTheme);
  const [show, setShow] = useState(false);
  const [notification, setNotification] = useState({ title: '', body: '' });
  const [newToken, setTokenFound] = useState(false);
  const [notificationData, setNotificationData] = useState('');

  React.useEffect(() => {
    fetchToken(setTokenFound)
    let loginToken = localStorage.getItem("token")
    if (newToken) {
      let existingToken = localStorage.getItem("fcm_token")
      if (newToken?.toString() !== existingToken?.toString() && loginToken) {
        updateFcmRegistration(newToken)
      }
    }
    if (!loginToken) {
      localStorage.clear();
    }
  }, [newToken])


  const updateFcmRegistration = (newToken) => {
    const url = POST_URL.fcmregister.api;
    let postData = {
      "registration_id": newToken,
      "type": "web"
    }
    postRequest(url, postData, props).then((response) => {
      if (response && response.status === 200) {
        localStorage.setItem("fcm_token", newToken);
      }
    });
  }

  React.useEffect(() => {
    onMessageListener().then(payload => {
      setNotification({ title: payload.notification.title, body: payload.notification.body })
      setNotificationData(() => payload)
      // setShow(true);
      // var message = new Notification(payload.notification.body)

      var message = new Notification(payload.notification.title, {
        icon: edubricz,
        body: payload.notification.body,
      });

      message.onclick = function (event) {
        const { host } = window.location
        let pathname = getPathName(payload.data)
        window.open(`https://${host}/${pathname}`);
      }
    }).catch(err => console.log('failed: ', err));
  }, []);

  const handleClose = () => {
    setShow(false);
    setNotification('');

  }


  let lastLogin = null;
  let refreshTime = null;
  let callingRefresTokenApi = false;
  let refreshTimeInUnix = 60000 * REFRESH_TOKEN_TIME;
  let bufferTimeInUnix = 60000 * TOKEN_EXPIRY_BUFFER_TIME;

  React.useEffect(() => {
    const body = document.getElementsByTagName('body');
    if (body) {
      body[0].classList.add(`theme-${theme}`);
    }
    const { host } = window.location;
    const trackingId = GATrackingIds.hasOwnProperty(host) && GATrackingIds[host];
    if (trackingId) {
      ReactGA.initialize(trackingId);
      ReactGA.set({ page: window.location.pathname });
      ReactGA.pageview(window.location.pathname + window.location.search);
    }
    if (!("Notification" in window)) {
      console.log("This browser does not support desktop notification");
    } else {
      Notification.requestPermission();
    }
  }, [props.location]);

  const checkTokenExpiry = () => {
    lastActivityTime = new Date().getTime();

    if (lastLogin && refreshTime < lastActivityTime && !callingRefresTokenApi) {
      const url = POST_URL.refresh_token.api;
      callingRefresTokenApi = true;
    }
  }

  const errorHandler = (error, stackTrace) => {
    let locationHref = window.location.href;
    const user = localStorage.getItem('user');
    let user_id = null;
    let username = ''
    if (user) {
      user_id = JSON.parse(user).id
      username = JSON.parse(user).username
    }
    const payload = [
      {
        notification_entity: {
          user_id: user_id,
          company_id: null,
          channel: 'email',
          vendor: 'ses',
          client: 'ses',
          priority: 'high',
          channel_data: {
            messageType: '',
            subject: `Web Error - screen ${locationHref}  - at (${moment().format('DD MMM YYYY HH:MM',)}) by user - ${username}`,
            to: errorReceivers,
            cc: [],
            body: `error - ${error} \n stack trace - ${JSON.stringify(stackTrace)}`,
            attachmentLinks: [],
          },
        },
      },
    ]
    if (window.location.protocol === "https:") {
      const url = NOTIFICATION_POST_URL.sendnotification.api;
      postNotificationRequest(url, payload, { return_error: true });
    }
  }

  const TransitionDown = (props) => {
    return <Slide {...props} direction="down" />;
  }


  return (
    // <ErrorBoundary
    //   FallbackComponent={ErrorFallback}
    //   onError={(error, info) => {
    //     errorHandler(error, info)
    //   }}
    // >
    <div className={`App`} onMouseMove={() => checkTokenExpiry()}>
      <Router>
        {/* <div>
          </div> */}
        {/* <ThemeToggle setTheme={setTheme}/> */}
        <Routes>
          <Route path="/" element={<Navigate to={localStorage.getItem('token') ? "/dashboard" : "/login"} />} />
          <Route path="/login" element={localStorage.getItem('token') ? <Navigate to="/dashboard" /> : <Loginpage/>} />
          <Route path="/*" element={<Dashboard/>} />
          <Route path="/schools-colleges" element={<SchoolCollegeSync/>}/>
    
          <Route element={<h3>Not Found</h3>} />
        </Routes>
      </Router>
      
      {/* Global Floating Chatbot */}      {/* {localStorage.getItem('token') && <ChatbotWidget />} */}
      <Snackbar open={show} autoHideDuration={6000} onClose={handleClose} TransitionComponent={TransitionDown}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }} style={{ marginTop: '30px' }}
      >
        <Alert onClose={handleClose} severity="info" sx={{ width: '100%' }}>
          {`${notification.title} - ${notification.body}`}
        </Alert>
      </Snackbar>
    </div>
    // </ErrorBoundary>
  );
}

const ErrorFallback = () => {
  return (
    <div role="alert">
      <img src="https://thefactfactor.com/wp-content/uploads/2020/03/Errors-01.png" style={{ margin: 'auto', display: 'block' }} />
      <Button
        variant="contained"
        color="primary"
        style={{ margin: 'auto', display: 'block' }}
        onClick={() => window.location.reload()}>
        Try again
      </Button>
    </div>
  )
}

ErrorFallback.propTypes = {
  error: PropTypes.object,
  resetErrorBoundary: PropTypes.func,
  location: PropTypes.object.isRequired
}

export default App;
